<template>
  <v-dialog max-width="600" v-model="dialog" @keydown.enter.prevent="onenter">
    <v-card>
      <v-card-title>
        <span class="headline">League Config ({{ this.rules.name }})</span>
        <v-spacer/>
        <r-authorize
            :master="masterAccess"
            :locked.sync="model.locked"
            :enabled.sync="model.enabled"
        />
      </v-card-title>
      <v-card-text>
        <v-col cols="4" sm="2" md="2">
          <v-btn @click="showPreview()" class="mr-2" small>View JSON</v-btn>
        </v-col>
        <v-row dense class="mt-3">
          <v-col cols="12" md="12" sm="12">
            <v-text-field disabled label="UID:" v-model.trim="model.uid" hide-details outlined dense/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Name:"
              v-model.trim="model.name"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field
              label="Key:"
              v-model.trim="model.key"
              v-ascii-only
            />
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <r-league-kind :model.sync="model.kind" label="Kind"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model.number="model.segmentTop" label="Users Top:" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model.number="model.segmentMiddle" label="Users Middle:" hide-details/>
          </v-col>
          <v-col cols="12" md="4" sm="4">
            <v-text-field v-model.number="model.segmentBottom" label="Users Bottom:" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="pt-6">
          <v-expansion-panels>
            <r-reward-bunch-panel :model.sync="model.achievement" title="Achievements" label="Achievement" :points="true"/>
            <r-reward-bunch-panel :model.sync="model.reward" title="Rewards" label="Reward" :points="true"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>
          Cancel
        </v-btn>
        <v-btn @click="save" color="blue darken-1" text v-if="!lockedAssess || masterAccess">
          Save
        </v-btn>
      </v-card-actions>
      <r-preview-dialog ref="preview-dialog"></r-preview-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {LeagueConfig} from "@/modules/redactor/models/leaderboard/LeagueConfig";

import RAuthorize from "@/modules/redactor/views/common/r-authorize.vue";
import RLeagueKind from "@/modules/redactor/views/server-events/leaderboard/r-league-kind.vue";
import RRewardBunchPanel from "@/modules/redactor/views/reward/r-reward-bunch-panel.vue";
import RPreviewDialog from "@/modules/redactor/views/preview/r-preview-dialog.vue";

export default {
  name: "r-league-config-dialog",
  components: {RPreviewDialog, RRewardBunchPanel, RLeagueKind, RAuthorize},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new LeagueConfig(),
    rules: ViewRules.READONLY,
    tab: null
  }),
  computed: {
    lockedAssess() {
      return this.model.locked;
    },
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new LeagueConfig();

      if (ViewRules.COPY.equal(this.rules)) {
        this.model.locked = false;
      }

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    },
    onenter() {
      if (!this.lockedAssess || this.masterAccess) {
        this.save();
      } else {
        this.cancel();
      }
    },
    showPreview() {
      this.$refs['preview-dialog'].show(this.rules, this.model, LeagueConfig)
        .then((result) => {
          Object.assign(this.model, result);
        })
        .catch((e) => {
          this.$alert("Failed to parse config!" + e.message);
        });
    }
  }
}
</script>